import $ from 'jquery';
import _ from 'lodash';
// @ts-ignore
import Turbolinks from 'javascripts/turbolinks';
import busyGif from 'images/busy.gif';
// @ts-ignore
import Shepherd from 'javascripts/shepherd';
import AhaBottomDrawer from 'javascripts/bottom_drawer';
import { flavoredPath } from 'javascripts/flavor';
import { updateReactiveParams } from 'javascripts/reactive_partial_params';
import { loadStubbedContentImmediately } from 'javascripts/stubbed_reactive_content';
import projectTimelineStore from 'components/ProjectTimeline/store';
import UserPreference from 'components/framework/models/UserPreference';
import AhaAnalytics from 'javascripts/analytics';
import { sanitizeHtml } from './utils';
import {
  saveKB,
  setCSSVariableInStyleTag,
} from './settings/account/knowledge_base/common';
import debounce from 'lodash/debounce';
import {
  type SelectroCallback,
  type SelectroController,
  type SelectroHTMLElement,
} from '@aha-app/selectro-v2';

let highlightProductTour = null;
let auditsChange = null;

const showSpinner = function () {
  $('.progress-menu-item').addClass('page-loading');
  $('body').css('cursor', 'wait');
};

const hideSpinner = function () {
  $('.progress-menu-item').removeClass('page-loading');
  $('body').css('cursor', 'auto');
};

const taskFiltersAnalyticsMap = {
  tasks_due_date_filter: 'Due',
  tasks_order: 'Order',
  tasks_type_filter: 'Type',
  tasks_workspace_filter: 'Workspace',
};

const updateUserDashboardBookmark = function (data) {
  showSpinner();

  const change = Object.entries(data);
  if (change.length > 0) {
    const [key, value] = change[0];
    const filter = taskFiltersAnalyticsMap[key];
    if (filter) {
      AhaAnalytics.track('Feature-7177135300784649975', 'User filters to-dos', {
        'Filter name': filter,
        Value: filter !== 'Workspace' ? value : undefined,
      });
    }
  }

  $.ajax({
    url: '/user_dashboard',
    type: 'PUT',
    data,
    complete: hideSpinner,
  });
};

const showMyWorkLoadingRows = function () {
  const loadingRows = document.querySelector(
    '#user-dashboard__records-loading-rows'
  );
  const recordsContainer = document.querySelector(
    '#user-dashboard__records-container'
  );
  const emptyResult = document.querySelector('.user-dashboard__empty');
  if (recordsContainer) {
    recordsContainer.classList.add('tw-hidden');
  }
  if (loadingRows) {
    // This is added again after the reactive update is applied.
    loadingRows.classList.remove('tw-hidden');
  }
  if (emptyResult) {
    emptyResult.classList.add('tw-hidden');
  }
  // Hide the empty message while showing loading rows.
  const emptyDisplay = document.querySelector('#empty-display');
  if (emptyDisplay) {
    emptyDisplay.classList.add('tw-hidden');
  }
};

const selectroMultipleValues = function (args) {
  const currentValues = args.previousSelected.map(option => option.value);

  let optionValues = [args.option.value];
  if (args.option.children) {
    optionValues = optionValues.concat(
      args.option.children.map(child => child.value)
    );
  }

  if (args.action === 'removed') {
    return _.difference(currentValues, optionValues);
  } else {
    return _.union(currentValues, optionValues);
  }
};

const auditsCriteria = function () {
  let filters = $(
    '.audit-filters input, input#timeframe, input#timeframe_range_'
  ).serialize();
  if (!filters.includes('user_id')) {
    // If the user_id filter is not present, add it with the current user id.
    filters = filters.concat(`&user_id=0`);
  }
  // @ts-ignore
  return `${filters}&q=${$('#history-search-form')[0]?.value}`;
};

/**
 * A helper to generate select/clear callbacks for selectro that will update
 * the closest reactive partial with the given param, and value from the selected
 * item (or null in the case of clear).
 * @param {string} field The reactive partial param to update
 * @param {(selectro: any) => void?=} callback An optional callback to run after
 * the update (e.g. to close the selectro), gets passed the selectro instance.
 */
function updateReactivePartialParam(
  field: string,
  callback?: (args: { controller: SelectroController; payload: any }) => void
) {
  return (args: { controller: SelectroController; payload: any }) => {
    const $target = args.controller.elementRef;
    const $reactiveContainer = $(
      $target?.closest('[data-reactive-url]') as HTMLElement
    );

    const partialParams = {
      [field]: args.payload?.item?.value,
      page: 1, // When the filter changes, force user back to page 1, as the filter may be such that the user's current page no longer exists.
    };

    updateReactiveParams($reactiveContainer, partialParams);

    if (typeof callback === 'function') callback(args);
  };
}

function scrollReactivePage(args) {
  const selectroElem = args.controller.elementRef;
  const reactiveElem = selectroElem?.closest('[data-reactive-url]');
  const scrollableElem = reactiveElem?.parentElement;
  if (scrollableElem) {
    scrollableElem.scrollTop = 0;
  }
}

const Callbacks = {
  clearWatchers(args) {
    const url = args.currentState.element.getAttribute(
      'data-clear_callback_url'
    );

    $.ajax({
      type: 'DELETE',
      url,
      dataType: 'json',
    });
  },

  updateWatcher(args) {
    const url = args.currentState.element.getAttribute('data-toggle_url');

    $.ajax({
      type: 'PUT',
      url,
      data: { watch: { user_id: args.option.value } },
      dataType: 'json',
    });
  },

  ProjectsMenu(args) {
    const { fromController } = window;
    const qs =
      fromController && fromController.length > 0
        ? `?from_controller=${fromController}`
        : '';

    if (args.option.meta && args.option.meta.myWorkLink) {
      window.AhaAnalytics.track(
        'Feature-7213418215123695933',
        'User selects My work in workspace switcher'
      );

      Turbolinks.visit(args.option.meta.myWorkLink);
      return;
    }

    // Save the selected project in local storage so we can choose the same
    // project with the same nesting later when opening the dropdown again
    window.localStorage.setItem('projects_menu.selected', args.option.value);

    Turbolinks.visit(
      flavoredPath(
        `/products/${args.option.meta.referencePrefix}/switch_to${qs}`,
        args.option.meta.flavor
      )
    );
  },
  ProjectsMenuV2Select(args) {
    const { fromController } = window;
    const qs =
      fromController && fromController.length > 0
        ? `?from_controller=${fromController}`
        : '';
    const selectedItem = args.payload.item;

    if (selectedItem.data && selectedItem.data.myWorkLink) {
      window.AhaAnalytics.track(
        'Feature-7213418215123695933',
        'User selects My work in workspace switcher'
      );

      Turbolinks.visit(selectedItem.data.myWorkLink);
      return;
    }

    // Save the selected project in local storage so we can choose the same
    // project with the same nesting later when opening the dropdown again
    window.localStorage.setItem(
      'projects_menu.selected',
      selectedItem.data.value
    );

    Turbolinks.visit(
      flavoredPath(
        `/products/${selectedItem.data.referencePrefix}/switch_to${qs}`,
        selectedItem.data.flavor
      )
    );
  },

  ProjectsMenuClose() {
    if (highlightProductTour) {
      highlightProductTour.cancel();
      highlightProductTour = null;
    }
  },

  InitializeProjectMenu(element, project) {
    // If we previously stored the project value and it matches the current
    // project, set the selectro value to the stored value. This will only
    // change it if the user had selected a nested team.
    const storedValue = window.localStorage.getItem('projects_menu.selected');
    if (typeof storedValue === 'string') {
      if (_.last(storedValue.split('/')) === String(project[1])) {
        const newStoredValue = [project[0], storedValue];
        element.dataset.selectrovalue = JSON.stringify([newStoredValue]);
      }
    }
  },

  ProjectsMenuFetch() {
    if (window.highlightDemoProduct && window.demoDataProductID) {
      $('.pulsing-dot__container').hide();

      // Need to create our own tour so it doesn't collide with our GettingStarted tours
      highlightProductTour = new Shepherd.Tour({
        defaults: {
          classes: 'shepherd-theme-arrows',
        },
      });

      const step = window.highlightDemoProduct.steps[0];
      step.attachTo = `.selectro-option[data-value="${window.demoDataProductID}"] right`;
      step.buttons = [
        {
          text: 'Got it',
          action: () => {
            highlightProductTour?.cancel(); // eslint-disable-line no-unused-expressions
            UserPreference.deleteUserPreference('highlight_demo_data_after');
            window.highlightDemoProduct = null;
          },
        },
      ];
      highlightProductTour.addStep(step.key, step);
      highlightProductTour.start();
    }

    if (window.trackingProjectMenuLoadTimeStart) {
      const loadTime = Date.now() - window.trackingProjectMenuLoadTimeStart;
      window.trackingProjectMenuLoadTimeStart = null;

      window.AhaAnalytics.track(
        'Feature-7213418215123695933',
        'User clicks workspace switcher ',
        {
          'Time to load': loadTime,
        }
      );
    }
  },

  MarkCheckboxAfterSelectroV2({
    controller,
  }: {
    controller: SelectroController;
  }) {
    $(
      controller.elementRef
        ?.closest('.control-group')
        ?.querySelector(':scope input[type="checkbox"]') as HTMLInputElement
    )
      .prop('checked', true)
      .trigger('change');
  },

  MarkCheckboxAfterSelectro(args) {
    const id = args.currentState.button_id;
    $(id).prop('checked', true).trigger('change');
  },

  BulkEditConvertToSelectro(args) {
    $('[data-convert-to-form]').addClass('hide');

    if (args.option) {
      const convertTo = args.option.value;
      $(`[data-convert-to-form=${convertTo}]`).removeClass('hide');

      Callbacks.MarkCheckboxAfterSelectro(args);
    }
  },

  UserEditProductPermission(args) {
    if (args.option) {
      $('.user-permission-selectro').show();
    }
    Callbacks.MarkCheckboxAfterSelectro(args);
  },

  CustomObjectsDropdown(args) {
    const $elem = $(args.currentState.element);
    $elem.find('.text').text(args.option.text);
    const url = $elem
      .attr('data-url')
      .replace('CUSTOM_OBJECT_DEFINITION_ID', args.option.value);

    $('body').attr('data-no-transition-cache', true); // Prevent caching.
    $.get(url);
  },

  UserDashboard: {
    SwitchUser(args) {
      updateUserDashboardBookmark({
        viewed_user_id: args.option.value,
      });
    },
    ShowLoadingRows(args) {
      showMyWorkLoadingRows();
    },
    AllRecords: {
      OrderChange(value) {
        showMyWorkLoadingRows();
        updateUserDashboardBookmark({
          all_work_group_by: value,
        });
      },
      FilterChange({ controller }: { controller: SelectroController }) {
        let { selected, state } = controller;
        const { name, valueWasTouched, type } = state;
        // If the value was not touched, do not update the bookmark
        if (!valueWasTouched) return;
        selected = selected.map(option => option.value);

        const emptyByType = {
          single: 'null',
          multiple: '[]',
          tree: '[]',
        }[type];

        const actualValueByType = {
          single: selected[0],
          multiple: selected,
          tree: selected,
        }[type];

        showMyWorkLoadingRows();
        updateUserDashboardBookmark({
          [`${name}`]: selected.length > 0 ? actualValueByType : emptyByType,
        });
      },
      SearchChange: debounce(
        function (value) {
          showMyWorkLoadingRows();
          updateUserDashboardBookmark({
            all_work_search_query: value,
          });
        },
        1000,
        { leading: false }
      ),
    },
    Releases: {
      SelectUser(args) {
        updateUserDashboardBookmark({
          releases_viewed_user: args.option.value,
        });
      },
      ReleaseChange(args) {
        updateUserDashboardBookmark({
          releases_viewed_release_id: args.option.value,
        });

        window.AhaAnalytics.track(
          'Feature-7194576518149789286',
          'User selects record on my work releases',
          {}
        );
      },
    },
    Features: {
      SelectUser: ({
        controller,
      }: Parameters<SelectroCallback<'select'>>[0]) => {
        updateUserDashboardBookmark({
          features_viewed_user: controller.selected[0].value,
        });
      },
      FilterProduct(args) {
        const product_ids = selectroMultipleValues(args);
        updateUserDashboardBookmark({
          features_product_ids: product_ids.length ? product_ids : '[]',
        });
      },
      ClearProduct(args) {
        updateUserDashboardBookmark({
          features_product_ids: '[]',
        });
      },
      DueDateChange(args) {
        updateUserDashboardBookmark({
          features_due_date_filter: args.option.value,
        });
      },
      ToggleParkingLots(args) {
        $.ajax({
          url: '/user_dashboard',
          type: 'PUT',
          data: { [args.id]: !args.hasAttribute('active') },
        });
      },
    },
    Initiatives: {
      SelectUser: ({
        controller,
      }: Parameters<SelectroCallback<'select'>>[0]) => {
        updateUserDashboardBookmark({
          initiatives_viewed_user: controller.selected[0].value,
        });
      },
      FilterProduct(args) {
        const product_ids = selectroMultipleValues(args);
        updateUserDashboardBookmark({
          initiatives_product_ids: product_ids.length ? product_ids : '[]',
        });
      },
      ClearProduct(args) {
        updateUserDashboardBookmark({
          initiatives_product_ids: '[]',
        });
      },
    },
    Tasks: {
      SelectUser: ({
        controller,
      }: Parameters<SelectroCallback<'select'>>[0]) => {
        showMyWorkLoadingRows();
        updateUserDashboardBookmark({
          tasks_viewed_user: controller.selected[0].value,
        });
      },
      FilterChange(args) {
        showMyWorkLoadingRows();
        updateUserDashboardBookmark({
          tasks_filter: args.option.value,
        });
      },
      DueDateChange(args) {
        showMyWorkLoadingRows();
        updateUserDashboardBookmark({
          tasks_due_date_filter: args.option.value,
        });
      },
      OrderChange(args) {
        showMyWorkLoadingRows();
        updateUserDashboardBookmark({
          tasks_order: args.option.value,
        });
      },
      TypeChange(args) {
        showMyWorkLoadingRows();
        updateUserDashboardBookmark({
          tasks_type_filter: args.option.value,
        });
      },
      WorkspaceChange(args) {
        showMyWorkLoadingRows();
        const project_ids = args.currentState.value.map(option => option.value);
        updateUserDashboardBookmark({
          tasks_workspace_filter: project_ids.length ? project_ids : '[]',
        });
      },
    },
    Ideas: {
      SelectUser: ({
        controller,
      }: Parameters<SelectroCallback<'select'>>[0]) => {
        updateUserDashboardBookmark({
          ideas_viewed_user: controller.selected[0].value,
        });
      },
      FilterProduct(args) {
        const product_ids = selectroMultipleValues(args);
        updateUserDashboardBookmark({
          ideas_product_ids: product_ids.length ? product_ids : '[]',
        });
      },
      ClearProduct(args) {
        updateUserDashboardBookmark({
          ideas_product_ids: '[]',
        });
      },
    },
    SharedPages: {
      SelectDocumentType: args => {
        updateUserDashboardBookmark({
          connected_pages_document_type: args.selected[0].value,
        });
      },
    },
  },

  Ideas: {
    MergeIdeas: {
      selectIdea() {
        document
          .querySelector('#create-release-submit')
          ?.removeAttribute('disabled');
      },
      bulkSelectro(args: { controller: SelectroController }) {
        Callbacks.MarkCheckboxAfterSelectroV2(args);
      },
    },
    AdminResponse: {
      bulkSelectro(args: { controller: SelectroController }) {
        Callbacks.MarkCheckboxAfterSelectroV2(args);
        if (args.controller.selected[0].value === 'add') {
          $('.admin-response-editor').removeClass('hidden');
        } else {
          $('.admin-response-editor').addClass('hidden');
        }
      },
    },
  },

  IdeaThemes: {
    SetIdeas: {
      selectroClosed({ controller }: { controller: SelectroController }) {
        const $ideasSelectro = $(
          controller.elementRef?.closest('#ideas-selectro') as Element
        );
        const ideaIds = Array.from(
          $ideasSelectro[0].querySelectorAll(
            ':scope input.SelectroV2__hidden-selected-input'
          )
        ).map(input => input.value);

        $.ajax({
          type: 'PUT',
          url: $ideasSelectro.closest('[data-url]').data('url'),
          data: JSON.stringify({
            ideas_idea_theme: {
              idea_ids: ideaIds.length === 0 ? [-1] : ideaIds,
            },
          }),
          dataType: 'json',
          contentType: 'application/json',
          success: function () {
            window.AhaAnalytics.track(
              'Feature-7432059090208538124',
              'User links idea to theme',
              {
                Location: 'Theme',
              }
            );
          },
        });
      },
    },
    SetThemesFromIdea() {
      window.AhaAnalytics.track(
        'Feature-7432059090208538124',
        'User links idea to theme',
        {
          Location: 'Idea',
        }
      );
    },
  },

  IdeaComments: {
    // triggers a change event on the hidden field so that other code can react to the change e.g.: IdeaCommentForm
    newCommentVisibilitySelected(args) {
      const visibility = args.controller.selected[0].value;

      $(
        args.controller.elementRef
          ?.closest('.idea-comment-new')
          .querySelector(':scope .idea-comment-new-content')
      ).trigger(`visibility:${visibility}`);
    },
  },

  IdeaUsers: {
    MergeToAhaUser: {
      AhaUserSelected(args) {
        document
          .getElementById('merge-idea-user-submit')
          .removeAttribute('disabled');
      },
    },
  },

  IdeasOrganizations: {
    MergeOrganizations: {
      selectOrganization() {
        document
          .querySelector('#organization_merge_submit')
          .removeAttribute('disabled');
      },
    },
    ProxyVotes: {
      selectOrganization(args: {
        controller: SelectroController;
        payload: any;
      }) {
        const submitBtn = document.getElementById('save-proxy-vote');
        if (submitBtn) {
          submitBtn.removeAttribute('disabled');
        }

        const userSelector = document.querySelector(
          '#idea_user_selector'
        ) as SelectroHTMLElement;
        // If user selector is not present, do nothing
        if (!userSelector) return;
        // current selected organization
        const selectedOrganization = args.payload.item.text;
        // Internal selectro-v2 state of the user selector
        const userSelectorSelectroState = userSelector.selectro;
        // URL to fetch users for the selected organization
        const ideaUserUrl = userSelectorSelectroState.state.custom.ideaUserUrl;
        // If ideaUserUrl and selectedOrganization are present, fetch users
        if (ideaUserUrl && selectedOrganization) {
          // Enable user selector
          userSelectorSelectroState.state.disabled = false;
          document
            .querySelectorAll('.idea-user-radios input[type=radio]')
            .forEach(function (btn) {
              btn.removeAttribute('disabled');
            });

          $.getJSON(ideaUserUrl, {
            idea_organization_name: selectedOrganization,
          }).done(data => {
            userSelectorSelectroState.items = data;

            if (userSelectorSelectroState.selected.length > 0) {
              const newSelection = userSelectorSelectroState.selected.filter(
                selectedItem => {
                  return data.some(item => item.value === selectedItem.value);
                }
              );
              userSelectorSelectroState.actionSetSelected(newSelection);
            }

            $('#existing-idea-user:hidden')
              .closest('aha-field')
              .find("div[slot='error']")
              .hide();
          });
        }
      },
    },
  },

  Settings: {
    homePageSelected(args) {
      const selectro = $(args.currentState.element);
      const selection = args.option;
      let names = selection.parents();
      names.push(selection);
      names = names.map(o => o.text);

      const triggerContent = selectro.find('.selectro-trigger-content')[0];
      if (triggerContent) {
        triggerContent.innerText = names.join(' › ');
      }

      if (args.currentState?.id === 'account_home_page') {
        AhaAnalytics.track(
          'Feature-7361188348973217592',
          'User sets account home page',
          {
            'Home page': args.option?.text,
          }
        );
      }

      // 120-124 are values for custom home page
      const CUSTOM_HOME_PAGE_VALUES = ['120', '121', '122', '123', '124'];
      if (CUSTOM_HOME_PAGE_VALUES.includes(args.option?.value)) {
        document
          .querySelector('#custom-home-page-url-container')
          ?.classList.remove('tw-hidden');

        const label = document.querySelector(
          '#custom-home-page-url-container label'
        );
        if (label) {
          const optText = args.option.text.split(' ')[1];
          label.innerText = `${_.capitalize(optText)} URL`;
        }
      } else {
        document
          .querySelector('#custom-home-page-url-container')
          ?.classList.add('tw-hidden');
      }
    },

    teamTransformCallback(response) {
      response.options.unshift({ text: 'Account-level team', value: null });
      return response;
    },

    Projects: {
      WorkflowMappings: {
        addMapping(event) {
          if (event?.option?.value) {
            $('#add_workflow_mapping').submit();
          }
        },
      },

      TeamMappings: {
        toggleNestedTeams(toggle, _event) {
          // Submit the form in the next event loop to ensure the active state is set
          setTimeout(() => {
            $(toggle).parents('form').submit();
            $(toggle).prop('disabled', true);
          }, 0);

          AhaAnalytics.track(
            'DEVELOP-1733',
            'User toggles nested teams in project team mapping',
            {
              'Nested teams': $(toggle).prop('active'),
            }
          );
        },

        addTeamMappings(...args) {
          if ($('#project_team_id .selectro-trigger-inputs input').length < 1) {
            // Nothing to submit
            return;
          }

          $('#project_team_id').attr('disabled', 'disabled');
          $('#add_team_mapping aha-spinner').show();

          $('#add_team_mapping').submit();

          const currentMappingCount = Math.max(
            0,
            $('#team-mappings-table tbody tr').length - 1
          );
          AhaAnalytics.track(
            'Feature-7138059272703443588',
            'User linked workspace to develop teams',
            {
              'Number of teams': currentMappingCount + 1,
            }
          );
        },
      },
    },

    Users: {
      RoleClosed() {
        $('#custom_role').prop(
          'checked',
          String($('button[name="role_id"]').prop('selectroValue')) !== '0'
        );
      },
    },

    Teams: {
      toggleNestedTeams(toggle, _event) {
        // Submit the form in the next event loop to ensure the active state is set
        setTimeout(() => $(toggle).parents('form').submit(), 0);

        AhaAnalytics.track(
          'DEVELOP-1733',
          'User toggles nested teams in account settings',
          {
            'Nested teams': $(toggle).prop('active'),
          }
        );
      },
    },
  },

  CustomPivot: {
    ColorByColumnSelected(event) {
      // Clear existing options so iripo properly detects the change
      // and color pickers are properly initiatiated after reactive patching
      // https://github.com/aha-app/aha-app/blob/a27a9d54f1611ff3ba75bb863a47767f3c66f0ed/app/assets/javascripts/bookmarks/custom_pivots.js#L269
      const existingOptions = document.querySelector('.color-palette-options');
      if (existingOptions)
        existingOptions.innerHTML = `<aha-spinner size="3.5ex" stroke="auto" color="auto" opacity="0.5" track="false" track-opacity="0.2" aria-busy="" aria-valuetext="Loading" role="progressbar"></aha-spinner>`;

      const { value } = event.currentState.value[0];
      const url = event.currentState.element.getAttribute('data-url');

      $.ajax({
        url,
        type: 'PUT',
        data: {
          bookmarks_custom_pivot: {
            configuration_color_by_column: value,
          },
        },
        dataType: 'json',
      });
    },

    OrderSelected(event) {
      const $selectro = $(event.currentState.element);
      const { value } = event.currentState.value[0];
      const scoped_name = $selectro.parent('.column-order').data('scoped-name');

      $(`.custom-pivot-multi-sort__${scoped_name}--asc`).text(
        event.option.sort_asc
      );
      $(`.custom-pivot-multi-sort__${scoped_name}--desc`).text(
        event.option.sort_desc
      );

      $selectro.siblings('input').val(value).trigger('change');
    },
  },

  Integrations: {
    getIntegrationTableState() {
      const $form = $('.modal-integration-updates form:visible');
      const $inputs = $form.find('.filters-container input');
      const $table = $form.find('table');
      if ($table.length > 0) {
        const sortOrder = $table.find('thead').attr('data-sort-order');
        const sortKey = (
          $table[0].querySelector(':scope thead th.active[data-sort-key]') ||
          $table[0].querySelector(':scope thead th[data-sort-key]')
        ).getAttribute('data-sort-key');

        let data = $inputs.serialize();
        data += `&sort=${sortKey}&sort_order=${sortOrder}`;

        $.ajax({
          url: $table.attr('data-filter-url'),
          type: 'GET',
          data,
        });
      }
    },
    templateSelectedCallback(event) {
      const $warning = $('.template-warning__workflow');
      $warning.find('ul').text('');

      if (event.option.meta.workflow_warnings.length > 0) {
        for (const msg of event.option.meta.workflow_warnings) {
          $warning.find('ul').append(`<li>${msg}</li>`);
        }
        $warning.show();
      } else {
        $warning.hide();
      }
    },
    updateSalesforceFiltersCount(attr, filter) {
      // When the user changes the Salesforce import filters we will update the
      // count of filters that are set even before the user has saved the form.
      const selectros = document.querySelectorAll(
        `.integration-form-field input[name*=${attr}][name*=selectro_text]`
      );

      const uniqueNames = new Set();
      selectros.forEach(selectro => {
        uniqueNames.add(selectro.name);
      });

      let msg = `${uniqueNames.size} filters set`;
      if (uniqueNames.size === 1) {
        msg = `1 filter set`;
      }

      document.getElementById(filter).textContent = msg;
    },
    updateSalesforceAccountFiltersCount() {
      Callbacks.Integrations.updateSalesforceFiltersCount(
        'attribute_salesforce_dynamic_filters',
        'account-filter-count'
      );
    },
    updateSalesforceContactFiltersCount() {
      Callbacks.Integrations.updateSalesforceFiltersCount(
        'attribute_salesforce_contact_dynamic_filters',
        'contact-filter-count'
      );
    },
  },

  // Selectro callbacks for managing array values
  SelectroList: {
    replace(args) {
      const url = args.currentState.element.getAttribute('data-toggle-url');
      const values = args.currentState.value.map(option => option.value);
      $('.navbar .progress-menu-item').addClass('page-loading');

      $.ajax({
        type: 'PUT',
        url,
        data: { values },
        dataType: 'json',
        complete() {
          $('.navbar .progress-menu-item').removeClass('page-loading');
        },
      });
    },

    toggle(args) {
      const url = args.currentState.element.getAttribute('data-toggle-url');
      const current_values = args.currentState.value.map(
        option => option.value
      );
      const previous_values = args.previousSelected.map(option => option.value);
      const values = _.difference(
        _.union(current_values, previous_values),
        _.intersection(current_values, previous_values)
      );
      $('.navbar .progress-menu-item').addClass('page-loading');

      $.ajax({
        type: 'PUT',
        url,
        data: { toggle: values },
        dataType: 'json',
        complete() {
          $('.navbar .progress-menu-item').removeClass('page-loading');
        },
      });
    },

    clear(args) {
      const url = args.currentState.element.getAttribute('data-toggle-url');
      const values = args.previousSelected.map(option => option.value);
      $('.navbar .progress-menu-item').addClass('page-loading');

      $.ajax({
        type: 'PUT',
        url,
        data: { toggle: values },
        dataType: 'json',
        complete() {
          $('.navbar .progress-menu-item').removeClass('page-loading');
        },
      });
    },
  },

  SelectroV2: {
    Bookmarks: {
      updateSharedInternallyWith({
        controller,
      }: {
        controller: SelectroController;
      }) {
        const reactInPLaceWrapper = controller.elementRef?.closest(
          '.react-in-place-wrapper'
        );
        if (!reactInPLaceWrapper) return;
        const props = reactInPLaceWrapper.dataset.reactProps;
        const url = JSON.parse(props).url;
        const values = controller.selected
          .map(({ value }) => value)
          .filter(value => value.toLowerCase() !== 'teams');
        $.ajax({
          type: 'PUT',
          url,
          data: { values },
          dataType: 'json',
        });
      },
    },
  },

  // Custom Records Field widget selection callback for selectro in bulk updates
  RecordsField: {
    Bulk: {
      update(args) {
        const checkbox = $(
          args.currentState.element.getAttribute('data-checkbox')
        );

        checkbox.prop('checked', true);
      },

      clear(args) {
        const checkbox = $(
          args.currentState.element.getAttribute('data-checkbox')
        );

        checkbox.prop('checked', false);
      },
    },
  },

  CreateSubRelease(args) {
    const product_id = args.option.value;
    const release_id =
      args.currentState.element.getAttribute('data-from_release');
    const url = `/master_releases/${release_id}/add_project_release`;

    $.post(url, { project_id: product_id });
  },

  SelectUsersForWorkflowBoard(args) {
    let user_ids = selectroMultipleValues(args);
    if (user_ids.length === 0) {
      user_ids = '[]';
    }
    const url = args.currentState.element.getAttribute('data-bookmark-url');
    const data = {
      bookmarks_feature_board: {
        configuration_users_shown: user_ids,
      },
    };
    showSpinner();

    $.ajax({
      type: 'PUT',
      url,
      data,
      dataType: 'json',
      complete() {
        hideSpinner();
      },
    });
  },

  ClearUsersForWorkflowBoard(args) {
    const url = args.currentState.element.getAttribute('data-bookmark-url');
    const data = {
      bookmarks_feature_board: {
        configuration_users_shown: '[]',
      },
    };
    showSpinner();

    $.ajax({
      type: 'PUT',
      url,
      data,
      dataType: 'json',
      complete() {
        hideSpinner();
      },
    });
  },

  SelectGroupingForWorkflowBoard(args) {
    const url = args.currentState.element.getAttribute('data-bookmark-url');

    const $showWorkPerUser = $('.feature-board-settings__show-work-per-user');
    const { value } = args.option;

    const configuration = {
      configuration_group_by: value,
    };

    if (value === 'assignee') {
      $showWorkPerUser.removeClass('disabled');
      $showWorkPerUser.children('input').prop('disabled', false);
    } else {
      $showWorkPerUser.addClass('disabled');
      $showWorkPerUser
        .children('input')
        .prop('disabled', true)
        .prop('checked', false);
      configuration.configuration_show_work_per_user = false;
    }

    showSpinner();

    $.ajax({
      type: 'PUT',
      url,
      data: { bookmarks_feature_board: configuration },
      dataType: 'json',
      complete() {
        hideSpinner();
      },
    });
  },

  SelectStatusForWorkflowBoard(selectroArgs, statusIds) {
    statusIds = statusIds || selectroMultipleValues(selectroArgs);
    if (statusIds.length === 0) {
      statusIds = '[]';
    }
    const url =
      selectroArgs.currentState.element.getAttribute('data-bookmark-url');
    const data = {
      bookmarks_feature_board: {
        configuration_workflow_status_shown: statusIds,
      },
    };
    showSpinner();

    $.ajax({
      type: 'PUT',
      url,
      data,
      dataType: 'json',
      complete() {
        hideSpinner();
      },
    });
  },

  ClearStatusForWorkflowBoard(selectroArgs) {
    Callbacks.SelectStatusForWorkflowBoard(selectroArgs, []);
  },

  InitiativesWorkflow: {
    SelectStatuses(args) {
      let data;
      const status_ids = selectroMultipleValues(args);

      if (status_ids.length === 0) {
        data = {
          bookmarks_initiative_workflow: {
            configuration_workflow_status_hidden: '[]',
          },
        };
      } else {
        data = {
          bookmarks_initiative_workflow: {
            configuration_workflow_status_shown: status_ids,
          },
        };
      }

      showSpinner();

      $.ajax({
        type: 'PUT',
        url: args.currentState.element.getAttribute('data-url'),
        data,
        dataType: 'json',
        complete() {
          hideSpinner();
        },
      });
    },

    ClearStatuses(args) {
      showSpinner();

      $.ajax({
        type: 'PUT',
        url: args.currentState.element.getAttribute('data-url'),
        data: {
          bookmarks_initiative_workflow: {
            configuration_workflow_status_hidden: '[]',
          },
        },
        dataType: 'json',
        complete() {
          hideSpinner();
        },
      });
    },

    SelectEpochs(args) {
      let epoch_ids = selectroMultipleValues(args);
      if (epoch_ids.length === 0) {
        epoch_ids = '[]';
      }

      showSpinner();

      $.ajax({
        type: 'PUT',
        url: args.currentState.element.getAttribute('data-url'),
        data: {
          bookmarks_initiative_workflow: {
            configuration_epochs_shown: epoch_ids,
          },
        },
        dataType: 'json',
        complete() {
          hideSpinner();
        },
      });
    },

    ClearEpochs(args) {
      showSpinner();

      $.ajax({
        type: 'PUT',
        url: args.currentState.element.getAttribute('data-url'),
        data: {
          bookmarks_initiative_workflow: {
            configuration_epochs_shown: '[]',
          },
        },
        dataType: 'json',
        complete() {
          hideSpinner();
        },
      });
    },
  },

  Notifications: {
    SelectProject: updateReactivePartialParam('filter[project_id]', args =>
      scrollReactivePage(args)
    ),
    SelectRecordType: updateReactivePartialParam('filter[record_type]', args =>
      scrollReactivePage(args)
    ),
    ClearProject: updateReactivePartialParam(
      'filter[project_id]',
      ({ controller }: { controller: SelectroController }) => {
        controller.actionToggleDropdown(false);
      }
    ),
    ClearRecordType: updateReactivePartialParam(
      'filter[record_type]',
      ({ controller }: { controller: SelectroController }) => {
        controller.actionToggleDropdown(false);
      }
    ),
  },

  NotificationPreferences: {
    SwitchUser: ({ controller }: Parameters<SelectroCallback<'select'>>[0]) => {
      location.assign(
        `/settings/users/${controller.value}/notification_preferences${location.search}`
      );
    },
  },

  SetProjectNotificationPreference(args) {
    const scope = args.currentState.preference_name;
    // projectId = args.currentState["project_id"]
    // currentState reads the id as a number which overflows and rounds
    // reading the data attribute of the element reads it as a string
    const projectId = $(args.currentState.element).data('project_id');
    const deliveryFrequency = args.option.value;
    const relativesClassPrefix = $(args.currentState.element).data(
      'relatives_class'
    );

    const parent = $(args.currentState.element);
    const element = $(args.currentState.element).find(
      '.selectro-trigger-content'
    );
    let children = $(
      `.inherited[data-value-from-${relativesClassPrefix}=${projectId}]`
    );
    if (children.length === 0) {
      children = $(`.inherited.${relativesClassPrefix}-${projectId}`);
    }
    // This pattern is discouraged but it is safe because busyGif is static.
    // eslint-disable-next-line no-unsanitized/method
    element.html(`<img src='${busyGif}'>`);
    // eslint-disable-next-line no-unsanitized/method
    children.html(`<img src='${busyGif}'>`);

    $.ajax({
      type: 'POST',
      url: args.currentState.endpoint,
      data: {
        project_id: projectId,
        value: deliveryFrequency,
        preference_name: scope,
      },
      dataType: 'json',
      complete(data) {
        // DO NOT REPLICATE: this pattern is unsafe and
        // would be vunlerable if updateValue were user controlled.
        const child_html = `<div> ${data.responseJSON.updateValue.replace(
          '(Inherited)',
          ''
        )} (Inherited) </div>`;
        children.html(sanitizeHtml(child_html));

        const parent_html = `<div> ${data.responseJSON.updateValue} </div>`;
        parent.html(sanitizeHtml(parent_html));

        if (data.responseJSON.updateValue.includes('Inherited')) {
          parent.addClass('inherited');
        } else {
          parent.removeClass('inherited');
        }

        children.attr(
          `data-value-from-${relativesClassPrefix}`,
          `${data.responseJSON.inheritedFromProjectId}`
        );
        parent.attr(
          `data-value-from-${relativesClassPrefix}`,
          `${data.responseJSON.inheritedFromProjectId}`
        );
      },
    });
  },

  Notebooks: {
    selectNotebook() {
      $('#modal-window button.select-notebook').removeAttr('disabled');
    },
  },

  Dashboards: {
    selectDashboard(args) {
      const dashboardId = args.option.value;
      $('#modal-window #dashboard_id').val(dashboardId);
      $('#modal-window button.select-dashboard').removeAttr('disabled');
    },
  },

  Audits: {
    AnyChange() {
      if (auditsChange) {
        auditsChange.abort();
      }

      $('body').addClass('page-loading-cursor');

      auditsChange = $.ajax({
        url: location.pathname + '.js',
        data: auditsCriteria(),
        complete: () => {
          $('body').removeClass('page-loading-cursor');
          auditsChange = null;
        },
      });
    },
    // Submit the search filter for an aha-search-fiels, showing the spinner
    // while it's loading
    ahaSearchFieldChange(ahaSearchField) {
      if (auditsChange) {
        auditsChange.abort();
      }

      ahaSearchField.setAttribute('loading', true);
      document.querySelector('#audits-index-timeout').style.display = 'none';
      document.querySelector('.audits-page').style.display = null;

      auditsChange = $.ajax({
        url: location.pathname + '.js',
        data: auditsCriteria(),
        complete: () => {
          auditsChange = null;
          ahaSearchField.removeAttribute('loading');
        },
        error: (jqXHR, textStatus, errorThrown) => {
          if (jqXHR.status === 504) {
            document.querySelector('#audits-index-timeout').style.display =
              null;
            document.querySelector('.audits-page').style.display = 'none';
          }
        },
      });
    },
  },

  PageNav: {
    filterChange() {
      const $filters = $('.page-nav-filters');
      const url = $filters.attr('data-url');

      $.ajax({
        url,
        data:
          $('.page-nav-filters input').serialize() + '&_loading_indicator=1',
      });
    },
    ahaSearchFieldChange(ahaSearchField) {
      const $filters = $('.page-nav-filters');
      const url = $filters.attr('data-url');

      ahaSearchField.setAttribute('loading', true);

      $.ajax({
        url,
        data: `search=${ahaSearchField.value}&_loading_indicator=1`,
        complete: () => {
          ahaSearchField.removeAttribute('loading');
        },
      });
    },
  },

  Features: {
    switchRelease(event) {
      const objectPref = event?.currentState?.element?.dataset?.object_pref;
      $('.progress-menu-item').addClass('page-loading');

      Turbolinks.visit(
        `/releases/${event.option.value}/features?object=${objectPref}`
      );
    },

    sortCards(args) {
      let url = args.currentState.element.getAttribute('data-callback_url');
      if (typeof url.includes === 'function' ? url.includes('?') : undefined) {
        url = url + '&';
      } else {
        url = url + '?';
      }

      $.ajax({
        url: url + 'order=' + args.currentState.value[0].value,
        success() {
          loadStubbedContentImmediately();
        },
      });
    },
  },

  Requirements: {
    switchFeature(event) {
      Turbolinks.visit(`/features/${event.option.value}/requirements`);
    },
  },

  ReleasePhases: {
    switchRelease(event) {
      Turbolinks.visit(`/releases/${event.option.value}/release_phases`);
    },
  },

  KeyResults: {
    switchStrategicImperative({
      controller,
    }: {
      controller: SelectroController;
    }) {
      Turbolinks.visit(
        `/strategic_imperatives/${controller.value}/key_results`
      );
    },
  },

  FeatureCards: {
    changeRelease() {
      Callbacks.FeatureCards.updateBookmark($('#release-picker').val());
    },

    clearReleases() {
      Callbacks.FeatureCards.updateBookmark('');
    },

    updateBookmark(releaseIds) {
      const selectroElement = $('#release-picker');

      $.ajax({
        type: 'PUT',
        url: selectroElement.data('update_url'),
        data: {
          bookmark: {
            configuration_release_ids: releaseIds.split(','),
          },
          reactive_client_id: window.reactiveClientId(),
        },
      });
    },

    limitCompletedItems(selectroData) {
      $.ajax({
        type: 'PUT',
        url: selectroData.currentState.data.update_url,
        data: {
          bookmark: {
            configuration_completed_limit: selectroData.option.value,
          },
          reactive_client_id: window.reactiveClientId(),
        },
      });
    },
  },

  Releases: {
    changeReleaseProgress(args) {
      $('.progress-menu-item').addClass('page-loading');

      location.assign(`/releases/${args.option.value}/progress`);
    },
  },

  CapacityReport: {
    resourceSelectedCallback(event) {
      const $el = $(event.currentState.element);
      const baseUrl = $el.data('base-url');

      AhaBottomDrawer.showUrl(`${baseUrl}&resource_id=${event.option.value}`);
    },
    changeCapacityReportScenario(args) {
      $(args.currentState.element).closest('form').submit();
    },
  },

  CapacityPlanningConfiguration: {
    updateTeams(args) {
      const url = args.currentState.element.getAttribute(
        'data-configuration-url'
      );
      const current_values = args.currentState.value.map(
        option => option.value
      );
      const data = {
        project_capacity_configuration: {
          default_teams: current_values,
        },
      };

      $.ajax({
        url,
        type: 'PUT',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(data),
      });
    },
  },

  EditBookmarkModal: {
    ToggleShareInternallyWithHelpText(selectro) {
      if (selectro.currentState.value.length !== 0) {
        $(selectro.currentState.element)
          .closest('form')
          .find('#share-internally-with-help')
          .css('visibility', 'hidden');
      } else {
        $(selectro.currentState.element)
          .closest('form')
          .find('#share-internally-with-help')
          .css('visibility', 'visible');
      }
    },
  },

  PortfolioRoadmap: {
    checkboxSelectedCallback(args) {
      const bookmarkId = $('#' + args.currentState.id)
        .parents('.page-nav__row')
        .attr('data-filter-bookmark-id');
      const ids = args.currentState.value.map(option => option.value);

      if (ids.length > 0) {
        $.ajax({
          type: 'PUT',
          url: `/bookmarks/portfolio_roadmaps/${bookmarkId}`,
          dataType: 'json',
          data: {
            id: bookmarkId,
            bookmarks_portfolio_roadmap: { configuration_project_ids: ids },
          },
        });
      } else {
        $.post(
          `/bookmarks/portfolio_roadmaps/${bookmarkId}/reset_project_ids.js`
        );
      }
    },

    checkboxClearCallback(args) {
      const bookmarkId = $('#' + args.currentState.id)
        .parents('.page-nav__row')
        .attr('data-filter-bookmark-id');

      $.ajax({
        type: 'POST',
        url: `/bookmarks/portfolio_roadmaps/${bookmarkId}/reset_project_ids.js`,
      });
    },

    autoupdateSection(args) {
      const projectId = args.option.value;
      const bookmarkId = $('#' + args.currentState.id)
        .parents('.page-nav__row')
        .attr('data-filter-bookmark-id');
      const addOrRemove = args.action === 'added' ? 'add' : 'remove';

      $('.portfolio').css('opacity', '0.33');
      $.ajax({
        type: 'PUT',
        url: `/bookmarks/portfolio_roadmaps/${bookmarkId}.js`,
        dataType: 'script',
        data: {
          id: bookmarkId,
          bookmarks_portfolio_roadmap: {
            [`configuration_${addOrRemove}_autoupdate_project_id`]: projectId,
          },
        },
      }).always(() => $('.portfolio').css('opacity', '1'));
    },
  },

  StrategyTree: {
    AnyChange(args) {
      const url = $(args.currentState.element)
        .parents('.page-nav__cell')
        .attr('data-url');
      let data = $(args.currentState.element).find('input').serialize();
      // If nothing is selected, we need to send an empty value
      if (!data) {
        data = `${encodeURIComponent(
          args.currentState.name
        )}=${encodeURIComponent('')}`;
      }
      $.ajax({
        url: url + '.js',
        method: 'put',
        data,
      });
    },
    SelectSelectroV2: (({ controller }) => {
      const { serializedInputValue: data, elementRef } = controller;
      if (!elementRef) return;
      const url = $(elementRef).parents('.page-nav__cell').attr('data-url');
      $.ajax({
        url: url + '.js',
        method: 'put',
        data,
      });
    }) as SelectroCallback<'select'>,
  },

  Users: {
    SelectUser(args) {
      $('body').css('cursor', 'wait');
      $('.progress-menu-item').addClass('page-loading');
      window.location.assign(`/users/${args.currentState.value[0].value}`);
    },
  },

  Timeline: {
    CustomFields(args, ajaxKey, store) {
      const elem = args.currentState.element;
      const keyPrefix = elem.getAttribute('data-field');
      const ajaxData = {};
      ajaxData[ajaxKey] = {};
      const reduxData = {};
      const reduxAction = `TOGGLE_${elem.getAttribute('data-redux-action')}`;

      args.previousSelected.forEach(function (item) {
        ajaxData[ajaxKey][`${keyPrefix}_${item.value}`] = 0;
        reduxData[`${item.value}`] = false;
      });

      args.currentState.value.forEach(function (item) {
        ajaxData[ajaxKey][`${keyPrefix}_${item.value}`] = 1;
        reduxData[`${item.value}`] = true;
      });

      const $form = $(this).parents('form').first();
      if ($form.find("input[name='reactive_client_id']").length === 0) {
        ajaxData.reactive_client_id = window.reactiveClientId();
      }

      $.ajax({
        url: elem.getAttribute('data-url'),
        method: 'put',
        data: ajaxData,
      });

      Object.keys(reduxData).forEach(id =>
        store.dispatch({
          type: reduxAction,
          payload: {
            toggle: reduxData[id],
            fieldId: id,
          },
        })
      );
    },
    FeatureCustomFields(args) {
      Callbacks.Timeline.CustomFields.call(
        null,
        args,
        'bookmarks_project_timeline',
        projectTimelineStore
      );
    },
    EpicCustomFields(args) {
      Callbacks.Timeline.CustomFields.call(
        null,
        args,
        'bookmarks_epic_timeline',
        projectTimelineStore
      );
    },
  },

  Search: {
    Sort(args) {
      $(args.currentState.element).closest('form').submit();
    },
  },

  Modal: {
    EnableSubmit: (({ controller }) => {
      if (!controller?.elementRef) return;

      $(controller.elementRef)
        .closest('form')
        .find("button[type='submit']")
        .removeAttr('disabled');
    }) as SelectroCallback<'select'>,
  },

  StrategicModels: {
    FiltersChanged(args) {
      const data = { id: $('.strategic-model').data('id'), bookmark: {} };
      for (const filter of Array.from(
        $(args.currentState.element.getAttribute('data-filter-group'))
      )) {
        const $selectro = $('.selectro-trigger', filter);
        const key = $selectro.attr('data-filter-key');
        data.bookmark[key] = JSON.parse(
          $selectro.attr('data-selectrovalue')
        ).map(pairs => pairs[1]);
      }

      $.ajax({
        url: args.currentState.element.getAttribute('data-callback-url'),
        contentType: 'application/json',
        type: 'POST',
        data: JSON.stringify(data),
      });
    },
  },

  StrategyGrid: {
    Filter(selectro) {
      let reactiveEl;
      const url = selectro.currentState.element.getAttribute('data-url');
      const filter =
        selectro.currentState.element.getAttribute('data-filter_type');
      const current_values = selectro.currentState.value.map(
        option => option.value
      );

      if (
        (reactiveEl = document.querySelector(
          '.sidebar-layout[data-reactive-url], .sidebar-layout__sidebar-list[data-reactive-url]'
        ))
      ) {
        // Use new reactive partial update
        updateReactiveParams($(reactiveEl), {
          filter,
          values: current_values,
        });
      } else {
        $('.progress-menu-item').addClass('page-loading');
        $.get(url, { filter, values: current_values }, function (data) {
          $('#workspace-content').replaceWith(
            $(data).find('#workspace-content')
          );
          $('#nav-content').replaceWith($(data).find('#nav-content'));
          $('.progress-menu-item').removeClass('page-loading');
        });
      }
    },
  },

  UserStoryMaps: {
    Filter(selectro) {
      const params = {};
      params.archived_filter = JSON.parse(
        document
          .getElementById('user-story-maps-archived-filter')
          .getAttribute('data-selectrovalue')
      )[0][1];

      const personasValue = JSON.parse(
        document
          .getElementById('user-story-maps-personas-filter')
          .getAttribute('data-selectrovalue')
      );
      if (personasValue && personasValue.length > 0) {
        params.personas_filter = personasValue.map(value => value[1]).join(',');
      }

      const rootPath = window.location.pathname.replace(/\/\d+$/, '');

      // Append the filter params to the url so they persist on page reload
      if (window.history.replaceState) {
        const formattedParams = Object.keys(params)
          .map(key => `${key}=${params[key]}`)
          .join('&');
        window.history.replaceState(
          undefined,
          undefined,
          `${rootPath}?${formattedParams}`
        );
      }

      $.ajax({ url: `${rootPath}.js`, data: params });
    },
  },

  ImportTrello: {
    WorkspaceSelected(selectro) {
      if (
        window.currentWorkspaceType === 'marketing_workspace' &&
        window.location.href.includes('analytics=true')
      ) {
        AhaAnalytics.track(
          'Feature-6664915770324112622',
          'User selects workspace for import from Trello'
        );
      }
    },
  },

  EpicGanttRoadmap: {
    UpdateEpicFilter(epic) {
      const reportId = location.pathname.split('/').slice(-1)[0];

      $.ajax({
        url: `/bookmarks/filterable/${reportId}/filters/epics_name`,
        type: 'PUT',
        data: {
          filter_config: {
            [epic.id]: true,
            filterName: 'epics_name',
          },
        },
      });

      // Update selectro
      const filter = document.querySelector(
        'button[name="filter_config[epics_name]"]'
      );

      if (filter) {
        // Remove cached selectro options
        filter.removeAttribute('data-options');

        // Add this epic to the list of pre-selected epics
        filter.value = `${filter.value},${epic.id}`;
        const selectroValue = JSON.parse(filter.dataset.selectrovalue);
        selectroValue.push([epic.name, epic.id]);
        filter.dataset.selectrovalue = JSON.stringify(selectroValue);

        // Add this epic to the values shown in the trigger element
        const textDiv = document.createElement('div');
        textDiv.innerText = epic.name;
        filter
          .querySelector(':scope .selectro-trigger-content')
          .appendChild(textDiv);

        // Add this epic to the values shown in the hidden inputs
        const inputs = filter.querySelector(':scope .selectro-trigger-inputs');
        if (inputs) {
          const inputElems = document.createRange().createContextualFragment(
            // TODO: i couldn't get this code to run so it may be dead. but as written it would allow for html injection from epic name.
            sanitizeHtml(
              `<input type='hidden' name='filter_config[epics_name]' value='${epic.id}' / ><input type='hidden' name='ⓢ_selectro_text[filter_config[epics_name]]' value='${epic.name}' />`
            )
          );
          inputs.appendChild(inputElems);
        }
      }
    },
  },

  IdeaSessions: {
    Filter(selectro) {
      let reactiveEl;

      const current_values = selectro.currentState.value.map(
        option => option.value
      );

      if (
        (reactiveEl = document.querySelector(
          '.sidebar-layout[data-reactive-url], .sidebar-layout__sidebar-list[data-reactive-url]'
        ))
      ) {
        // Use new reactive partial update
        updateReactiveParams($(reactiveEl), {
          values: current_values.length > 0 ? current_values : '[]',
        });
      }
    },
  },

  IdeaPortalIdentityProviders: {
    OnSelect(selectro) {
      const { value } = selectro.option;
      const { url } = selectro.currentState;

      // Any selected providers from the list are guaranteed to be enabled
      // hide "disabled" warning messages for the current provider
      $('.js-disabled-provider-warning').hide();

      $.ajax({
        url,
        type: 'PUT',
        data: {
          ideas_idea_portal: {
            idea_portal_identity_provider_id: value,
          },
        },
        dataType: 'json',
        success() {
          window.location.reload();
        },
      });
    },
  },

  ProgramIncrementTeams: {
    OnSelect(selectro) {
      const teamsSelected = Array.isArray(selectro.currentState.value)
        ? selectro.currentState.value.length
        : 0;
      if (teamsSelected > 0) {
        $('#iterations-summary-table')
          .find('.pi-iterations-modal__teams-count')
          .text(`${teamsSelected} ${teamsSelected !== 1 ? 'teams' : 'team'}`);
        $('#iterations-summary-table').show();
        $('#program-increment-teams-submit').removeAttr('disabled');
      } else {
        $('#iterations-summary-table').hide();
        $('#program-increment-teams-submit').attr('disabled', 'disabled');
      }
    },
  },
  ProgramIncrementAttribute: {
    OnSelect({ controller }: { controller: SelectroController }) {
      const wrapper = controller.elementRef?.closest('.react-in-place-wrapper');
      if (!wrapper) return;
      const props = wrapper.dataset.reactProps;
      const { url, object } = JSON.parse(props);

      $.ajax({
        type: 'PUT',
        url,
        data: {
          [object]: {
            program_increment_id: controller.value,
          },
        },
        dataType: 'json',
        success(data) {
          AhaAnalytics.track(
            'Feature-7029009676243324002',
            'User assigns record to program increment',
            {
              'Record type': object.capitalize(),
              'Record ID': data.program_increment_id,
            }
          );
        },
      });
    },
  },
  Polls: {
    changeSelectionType({
      controller,
      payload,
    }: {
      controller: SelectroController;
      payload: any;
    }) {
      Callbacks.Polls.changeQuestionTypeAttribute({
        controller,
        payload,
      });
    },
    changeQuestionType({
      controller,
      payload,
    }: {
      controller: SelectroController;
      payload: any;
    }) {
      Callbacks.Polls.changeQuestionTypeAttribute({
        controller,
        payload,
        analyticsOptions: {
          reference: 'Feature-7177847088826609689',
          event_name: 'User changes poll question type',
        },
      });
    },
    changeQuestionTypeAttribute({
      controller,
      payload,
      analyticsOptions,
    }: {
      controller: SelectroController;
      payload: any;
      analyticsOptions?: { reference: string; event_name: string };
    }) {
      const wrapper = controller.elementRef?.closest('.react-in-place-wrapper');
      if (!wrapper) return;
      if (!controller.value) return;

      const props = wrapper.dataset.reactProps;
      const { field, object, url } = JSON.parse(props) as {
        field: string;
        object: string;
        url: string;
      };

      const hasAnswers = wrapper.classList.contains('has-answers');
      // We don't delete answers when changing to multiple selection type
      const isChangingToMultiple =
        field === 'selection_type' && payload.item.value === 'multiple';
      const requiresConfirmation = hasAnswers && !isChangingToMultiple;

      if (!requiresConfirmation) {
        if (analyticsOptions) {
          window.AhaAnalytics.track(
            analyticsOptions.reference,
            analyticsOptions.event_name,
            {
              [field]: payload.item.text,
            }
          );
        }

        $.ajax({
          type: 'PUT',
          url,
          data: { [object]: { [field]: controller.value } },
          dataType: 'json',
        });

        return;
      }

      const prevItem = controller.items.find(
        i => i.value === controller.state.previousState.selected[0].value
      );

      // This replaces html with existing html.
      // eslint-disable-next-line no-unsanitized/method
      $('#modal-window').html(
        $('#poll-confirm-question-type-change-template').html()
      );

      $('#modal-window')
        .removeClass('modal-massive modal-big modal-flex modal-flex-max-width')
        .addClass('tw-w-fit')
        .modal('show');
      const $yesButton = $('#poll-confirm-question-type-change-confirm');

      $yesButton.prop('action', url);
      if (analyticsOptions) {
        $yesButton.find('.btn').attr(
          'data-track-click',
          JSON.stringify({
            ...analyticsOptions,
            props: { [field]: payload.item.text },
          })
        );
      }

      $yesButton
        .find('input[name="question_placeholder"]')
        .attr('name', `question[${field}]`)
        .val(controller.value);

      const onCancel = () => {
        controller.selectItem({ item: prevItem });
        $('#modal-window').modal('hide').removeClass('tw-w-fit');
      };

      $('#poll-confirm-question-type-change-cancel').rebind(
        'click.confirm-question-type-change',
        onCancel
      );
      $('#poll-confirm-question-type-change-header').rebind(
        'aha-modal-header:close.confirm-question-type-change-hide-modal',
        onCancel
      );
    },
  },
  ProductValueReports: {
    changeRelease() {
      window.AhaAnalytics.track(
        'Feature-7028986905776971276',
        'User filters product value report',
        {
          'Filter name': 'release',
          'Filter action': 'change',
        }
      );
      Callbacks.ProductValueReports.updateBookmark(
        'configuration_release_ids',
        $('#product-value__release-picker').val().split(','),
        Callbacks.ProductValueReports.getUrlFromV1(
          '#product-value__release-picker'
        )
      );
    },
    clearReleases() {
      window.AhaAnalytics.track(
        'Feature-7028986905776971276',
        'User filters product value report',
        {
          'Filter name': 'release',
          'Filter action': 'clear',
        }
      );
      Callbacks.ProductValueReports.updateBookmark(
        'configuration_release_ids',
        '',
        Callbacks.ProductValueReports.getUrlFromV1(
          '#product-value__release-picker'
        )
      );
    },
    changeInitiatives: (({ controller }) => {
      window.AhaAnalytics.track(
        'Feature-7028986905776971276',
        'User filters product value report',
        {
          'Filter name': 'initiative',
          'Filter action': 'change',
        }
      );
      Callbacks.ProductValueReports.updateBookmark(
        'configuration_initiatives_ids',
        controller.selected.map(({ value }) => value),
        controller.state.custom.updateUrl
      );
    }) as SelectroCallback<'select'>,
    clearInitiatives: (({ controller }) => {
      window.AhaAnalytics.track(
        'Feature-7028986905776971276',
        'User filters product value report',
        {
          'Filter name': 'initiative',
          'Filter action': 'clear',
        }
      );
      Callbacks.ProductValueReports.updateBookmark(
        'configuration_initiatives_ids',
        '',
        controller.state.custom.updateUrl
      );
    }) as SelectroCallback<'clearAll'>,
    changeTimeframe() {
      const timeframeValue = $('#product-value__timeframe-picker').val();
      window.AhaAnalytics.track(
        'Feature-7028986905776971276',
        'User changes timeframe on product value report',
        {
          Timeframe: timeframeValue,
        }
      );
      Callbacks.ProductValueReports.updateBookmark(
        'configuration_timeframe',
        timeframeValue,
        Callbacks.ProductValueReports.getUrlFromV1(
          '#product-value__timeframe-picker'
        )
      );
    },
    changeProject() {
      window.AhaAnalytics.track(
        'Feature-7028986905776971276',
        'User filters product value report',
        {
          'Filter name': 'workspace',
          'Filter action': 'change',
        }
      );
      Callbacks.ProductValueReports.updateBookmark(
        'configuration_project_ids',
        $('#product-value__project-picker').val().split(','),
        Callbacks.ProductValueReports.getUrlFromV1(
          '#product-value__project-picker'
        )
      );
    },
    clearProject() {
      window.AhaAnalytics.track(
        'Feature-7028986905776971276',
        'User filters product value report',
        {
          'Filter name': 'workspace',
          'Filter action': 'clear',
        }
      );
      Callbacks.ProductValueReports.updateBookmark(
        'configuration_project_ids',
        '',
        Callbacks.ProductValueReports.getUrlFromV1(
          '#product-value__project-picker'
        )
      );
    },
    getUrlFromV1(selector: string) {
      return (document.querySelector(selector) as HTMLElement).dataset
        .update_url;
    },
    updateBookmark(key, value, url) {
      $.ajax({
        type: 'PUT',
        url,
        data: {
          bookmarks_product_value_report: {
            [key]: value,
          },
        },
      });
    },
  },
  StrategicImperatives: {
    Sort(sortKey) {
      let reactiveEl;

      if (
        (reactiveEl = document.querySelector(
          '.sidebar-layout__sidebar-list[data-reactive-url]'
        ))
      ) {
        updateReactiveParams($(reactiveEl), {
          sort: sortKey,
        });
      }
    },
  },
  KnowledgeBases: {
    linkItemToPage({
      controller: { elementRef, value },
    }: {
      controller: SelectroController;
    }) {
      saveKB(
        { target: elementRef },
        {
          fieldName: 'knowledge_base_section_item',
          attributes: {
            page_id: value,
          },
        }
      );
    },
    selectFontFamily({
      payload: {
        item: {
          value,
          data: { font },
        },
      },
      controller: { elementRef },
    }: {
      controller: SelectroController;
      payload: any;
    }) {
      saveKB(
        { target: elementRef },
        {
          configuration: { 'customization.font_family': value },
          onSuccess: () => {
            setCSSVariableInStyleTag(
              '#kb-theme-styles',
              'body',
              '--aha-editor--user-font-family',
              font
            );
          },
        }
      );
    },
    selectHeadingsFontFamily({
      payload: {
        item: {
          value,
          data: { font },
        },
      },
      controller: { elementRef },
    }: {
      controller: SelectroController;
      payload: any;
    }) {
      saveKB(
        { target: elementRef },
        {
          configuration: { 'customization.heading_font_family': value },
          onSuccess: () => {
            setCSSVariableInStyleTag(
              '#kb-theme-styles',
              'body',
              '--aha-editor--user-heading-font-family',
              font
            );
          },
        }
      );
    },
    selectDefaultLanguage({
      controller: { elementRef, value },
    }: {
      controller: SelectroController;
    }) {
      saveKB(
        { target: elementRef },
        {
          configuration: {
            'translation.default_language': value,
          },
        }
      );
    },
    selectAvailableLanguages({
      controller: {
        elementRef,
        selected,
        state: {
          previousState: { selected: lastSelected },
        },
        props: { items },
      },
    }: {
      controller: SelectroController;
    }) {
      saveKB(
        { target: elementRef },
        {
          configuration: {
            'translation.available_languages': items?.reduce((acc, item) => {
              // We want null in the false case here so the code on the backend strips
              // them out in the database
              acc[item.value] = selected.find(s => s.value === item.value)
                ? true
                : null;

              return acc;
            }, {}),
          },
          onSuccess: () => {
            // Maually reload the glossary list, so the list of languages there is
            // updated to match the selected languages here.
            const $reactiveContainer = $('#knowledge-base-terms-list');
            updateReactiveParams($reactiveContainer, {});
          },
        }
      );

      const newItem = selected.filter(
        item => !lastSelected.find(ls => ls.value === item.value)
      );

      if (newItem.length) {
        window.AhaAnalytics.track(
          'Feature-7432433224189934761',
          'User adds KB translation language',
          {
            Language: newItem[0].value,
          }
        );
      }
    },
    selectTargetLanguage({
      controller: { value },
    }: {
      controller: SelectroController;
    }) {
      const $reactiveContainer = $('#knowledge-base-terms-list');

      updateReactiveParams($reactiveContainer, {
        language_code: value,
      });
    },
  },

  DiscoveryCalendar: {
    changeProject() {
      Callbacks.DiscoveryCalendar.updateBookmark({
        project_ids: $('#project-picker').val(),
      });
    },

    clearProjects() {
      Callbacks.DiscoveryCalendar.updateBookmark({
        project_ids: '',
      });
    },

    changeStudy() {
      Callbacks.DiscoveryCalendar.updateBookmark({
        discovery_study_ids: String($('#study-picker').val()).split(','),
      });
    },

    clearStudies() {
      Callbacks.DiscoveryCalendar.updateBookmark({
        discovery_study_ids: '',
      });
    },

    updateBookmark(data) {
      const selectroElement = $('#project-picker');

      $.ajax({
        type: 'PUT',
        url: selectroElement.data('update_url'),
        data: {
          bookmarks_discovery_calendar: data,
          skip_redirect: true,
          reactive_client_id: window.reactiveClientId(),
        },
      });
    },
  },

  DiscoveryInterview: {
    changeMode(args) {
      const interviewForm = $('#interview-modal-form');
      const meetingLinkInput = interviewForm.find(
        'input[name="discovery_interview[meeting_url]"]'
      );
      const meetingLinkField = meetingLinkInput.closest('aha-field');

      if (args.selected[0].value === 'video') {
        meetingLinkField.removeClass('tw-hidden');
      } else {
        meetingLinkField.addClass('tw-hidden');
        (meetingLinkInput[0] as HTMLInputElement).value = '';
      }
    },
  },

  DiscoveryMessagingCenter: {
    changeProject() {
      const url = $('#project-picker').data('update_url');
      Callbacks.DiscoveryMessagingCenter.updateBookmark(url, {
        project_ids: String($('#project-picker').val()).split(','),
      });
    },

    clearProjects() {
      const url = $('#project-picker').data('update_url');
      Callbacks.DiscoveryMessagingCenter.updateBookmark(url, {
        project_ids: [],
      });
    },

    changeStudy() {
      const url = $('#study-picker').data('update_url');
      Callbacks.DiscoveryMessagingCenter.updateBookmark(url, {
        discovery_study_ids: String($('#study-picker').val()).split(','),
      });
    },

    clearStudies() {
      const url = $('#study-picker').data('update_url');
      Callbacks.DiscoveryMessagingCenter.updateBookmark(url, {
        discovery_study_ids: [],
      });
    },

    updateBookmark(url, config) {
      $.ajax({
        type: 'PUT',
        url: url,
        data: {
          bookmarks_discovery_messaging_center: config,
          skip_redirect: true,
          reactive_client_id: window.reactiveClientId(),
        },
      });
    },
  },

  DiscoveryStudy: {
    changeDefaultUserService({ payload }) {
      const userID = payload.item.data.value;
      const url = payload.item.data.update_url;
      $.ajax({ type: 'POST', url, data: { user_id: userID } });
    },

    changeSchedulingOpen(ahaSwitch, schedulingOpen) {
      $.ajax({
        type: 'PUT',
        url: $(ahaSwitch).data('update_url'),
        data: {
          discovery_study: {
            scheduling_open: schedulingOpen,
          },
          skip_redirect: true,
          reactive_client_id: window.reactiveClientId(),
        },
      });
    },
  },

  RequirementsFilter: {
    OnSelect: (({ controller }) => {
      const selectedStatuses = controller.selected.map(s => s.value);
      const dataAttribute = window.currentProject?.isTeam
        ? 'data-team-workflow-status-id'
        : 'data-workflow-status-id';

      document
        .querySelectorAll('.requirements-list [' + dataAttribute + ']')
        .forEach(item => {
          const statusId = item.getAttribute(dataAttribute);
          if (
            selectedStatuses.length === 0 ||
            selectedStatuses.includes(statusId.toString())
          ) {
            item.style.display = '';
          } else {
            item.style.display = 'none';
          }
        });
    }) as SelectroCallback<'select'>,
  },

  TeamLocationAttribute: {
    OnSelect: ({ controller }) => {
      const selectedValue = controller.selected.map(s => s.value)[0];
      const container = controller.elementRef?.closest(
        '.attribute__value-container'
      );
      if (!container) return;

      const controls = container.querySelector(
        ':scope .attribute__value-controls .btn'
      );
      if (!controls) return;

      const wrapper = container.querySelector(':scope .react-in-place-wrapper');
      if (!wrapper) return;

      const props = wrapper.dataset.reactProps;
      const { url, object } = JSON.parse(props) as any;

      $.ajax({
        type: 'PUT',
        url,
        data: {
          [object]: {
            team_location: controller.value,
          },
        },
        dataType: 'json',
      });

      const prefix = controls
        .getAttribute('href')
        ?.match(/\/products\/[A-Z]+\//)?.[0];

      if (!prefix) return;

      let newHref = prefix;

      // Approx copy of the logic in team_location_path
      if (
        selectedValue === 'backlog' ||
        selectedValue === 'backlog-prioritized'
      ) {
        newHref += 'backlogs';
      } else if (selectedValue.startsWith('iterationplan-')) {
        newHref += 'iterations';
      } else {
        newHref += 'workflow_boards';
      }

      controls.setAttribute('href', newHref);
    },
  },
};

export default Callbacks;
